export default "__VITE_ASSET__DUbj3miE__"